// Закреплённые задачи — личная настройка: дорожка проекта в шапке видна только тому, кто закрепил.
// Спека 2026-09-14-display-settings.
import { useMemo } from 'react';
import { data, useSetting } from '@core/store';

export const PINS = 'pins';

export function usePins(): Set<string> {
  const [pins] = useSetting<string[]>(PINS, []);
  return useMemo(() => new Set(pins), [pins]);
}

export const isPinned = (id: string): boolean => data.setting<string[]>(PINS, []).includes(id);

export async function togglePin(id: string): Promise<void> {
  const now = data.setting<string[]>(PINS, []);
  await data.setSetting(PINS, now.includes(id) ? now.filter((x) => x !== id) : [...now, id]);
}
